import { render } from "./App.vue?vue&type=template&id=74c35f8e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=74c35f8e&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/vue-smart-reco-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__